var map = {
	"./answerpage/answerpage.module": [
		"./src/app/answerpage/answerpage.module.ts",
		"common",
		"answerpage-answerpage-module"
	],
	"./gamepage/gamepage.module": [
		"./src/app/gamepage/gamepage.module.ts",
		"common",
		"gamepage-gamepage-module"
	],
	"./intropage/intropage.module": [
		"./src/app/intropage/intropage.module.ts",
		"common",
		"intropage-intropage-module"
	],
	"./lessonselectpage/lessonselectpage.module": [
		"./src/app/lessonselectpage/lessonselectpage.module.ts",
		"common",
		"lessonselectpage-lessonselectpage-module"
	],
	"./loginpage/loginpage.module": [
		"./src/app/loginpage/loginpage.module.ts",
		"loginpage-loginpage-module"
	],
	"./pdfpage/pdfpage.module": [
		"./src/app/pdfpage/pdfpage.module.ts",
		"pdfpage-pdfpage-module"
	],
	"./playerpage/playerpage.module": [
		"./src/app/playerpage/playerpage.module.ts",
		"common",
		"playerpage-playerpage-module"
	],
	"./questionpreviewpage/questionpreviewpage.module": [
		"./src/app/questionpreviewpage/questionpreviewpage.module.ts",
		"common",
		"questionpreviewpage-questionpreviewpage-module"
	],
	"./questionspage/questionspage.module": [
		"./src/app/questionspage/questionspage.module.ts",
		"common",
		"questionspage-questionspage-module"
	],
	"./registerpage/registerpage.module": [
		"./src/app/registerpage/registerpage.module.ts",
		"common",
		"registerpage-registerpage-module"
	],
	"./resetpasspage/resetpasspage.module": [
		"./src/app/resetpasspage/resetpasspage.module.ts",
		"resetpasspage-resetpasspage-module"
	],
	"./staredlistpage/staredlistpage.module": [
		"./src/app/staredlistpage/staredlistpage.module.ts",
		"common",
		"staredlistpage-staredlistpage-module"
	],
	"./statspage/statspage.module": [
		"./src/app/statspage/statspage.module.ts",
		"common",
		"statspage-statspage-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;